import { useEffect } from "react";
import { useDocumentTitleValue } from "./use-document-title-value";

/**
 * Keeps the browser-tab title in sync with the current route.
 *
 * Mounted once in __root.tsx. Renders nothing.
 *
 * The title is assigned imperatively rather than rendered as a <title> element.
 * React 19 hoists a rendered <title> into <head> but does not deduplicate it,
 * and index.html already ships <title>Moby</title> — measured: two elements end
 * up in <head>. Assigning document.title leaves exactly one, keeps the static
 * title working as the pre-mount fallback, and relies on nothing undocumented.
 * See plans/page-document-titles/00-overview.md ("Step 0 result").
 */
export function DocumentTitle() {
	const title = useDocumentTitleValue();

	useEffect(() => {
		document.title = title;
	}, [title]);

	return null;
}
